export const GET_FLASH_MESSAGES_LIST = null;
export const SELECTED_FLASH_MESSAGE_ID = null;